import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import '../src/index.css';
import { Provider } from 'react-redux';
import Store from './app/Store.js';

import { Toaster } from 'react-hot-toast';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={Store}>
      <Toaster position='top-center' reverseOrder={false} />
      <App />
    </Provider>
  </React.StrictMode>
);
